import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../api/client.js';

const TenantAdminAuthContext = createContext(null);

export function TenantAdminAuthProvider({ children }) {
  // status: 'loading' | 'authenticated' | 'anonymous'
  const [state, setState] = useState({ status: 'loading', identity: null });

  const refresh = useCallback(async () => {
    try {
      const identity = await api.get('/api/tenant-admin/auth/me');
      setState({ status: 'authenticated', identity });
    } catch {
      setState({ status: 'anonymous', identity: null });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const identity = await api.post('/api/tenant-admin/auth/login', { email, password });
    setState({ status: 'authenticated', identity });
  }, []);

  const logout = useCallback(async () => {
    await api.post('/api/tenant-admin/auth/logout');
    setState({ status: 'anonymous', identity: null });
  }, []);

  return (
    <TenantAdminAuthContext.Provider value={{ ...state, login, logout, refresh }}>{children}</TenantAdminAuthContext.Provider>
  );
}

export function useTenantAdminAuth() {
  const ctx = useContext(TenantAdminAuthContext);
  if (!ctx) throw new Error('useTenantAdminAuth must be used within TenantAdminAuthProvider');
  return ctx;
}
